export default __webpack_public_path__ + "media/images/corporate/hero/sm-e5fe53759284cbaca4d0619f2bb68088.webp";